import React from "react";
import PageHeader from "../../components/PageHeader";
import CouponListComponent from "../../components/Coupon/CouponList";

class CouponList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Coupons"
                            Breadcrumb={[
                                { name: "Coupons", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CouponListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CouponList;
